export default {
    data: () => ({
        translations: {
            
            welcome: {
                el: "Καλώς ήρθατε στη RoadCube ",
                en: "Welcome to RoadCube ",
                it: "Benvenuti a RoadCube "
            },
            welcomeBack: {
                el: "Καλώς ήρθατε ",
                en: "Welcome Back ",
                it: "Bentornato"
            },
            enter: {
                el: " Εισάγετε τα στοιχεία σας για να συνδεθείτε. ",
                en: " Enter your credentials to log in. ",
                it: " Inserire le proprie credenziali per accedere.  "
            },
            createA: {
                el: "Δημιουργία ",
                en: "Create a ",
                it: "Crea "
            },
            newAccount: {
                el: " Λογαριασμού",
                en: " new Account",
                it: " account"
            },
            country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            mobile: {
                el: "Κινητό τηλέφωνο",
                en: "Mobile Phone",
                it: "Telefono cellulare"
            },
            password: {
                el: "Κωδικός πρόσβασης",
                en: "Password",
                it: "Password"
            },
            logIn: {
                el: "Συνδεση",
                en: "Log in",
                it: "Accedere"
            },
            logout: {
                el: "αποσυνδεση",
                en: "logout",
                it: "logout"
            },
            myStores: {
                el: "Τα καταστήματά μου",
                en: "My Stores",
                it: "I miei negozi"
            },
            
            iAccept: {
                el: "Αποδέχομαι τους",
                en: "I accept the",
                it: "Accetto"
            },
            terms: {
                el: "'Ορους υπηρεσιών'",
                en: "Terms of Services",
                it: "Termini di servizio"
            },
            and: {
                el: "και την",
                en: "and",
                it: "e"
            },
            policy: {
                el: "Πολιτική απορρήτου",
                en: "Privacy Policy",
                it: "Informativa sulla privacy"
            },
            alreadyAccount: {
                el: "Έχετε ήδη λογαριασμό?",
                en: "Already have an account?",
                it: "Avete già un account?"
            },
            signIn: {
                el: "Συνδεθείτε",
                en: "Sign In",
                it: "Accedi"
            },
            here: {
                el: "εδώ",
                en: "here",
                it: "qui"
            },
            register: {
                el: "εγγραφή",
                en: "register",
                it: "registro"
            },
            notRegistered: {
                el: "Δεν είστε εγγεγραμμένος;",
                en: "Not registered? ",
                it: "Non siete registrati? "
            },
            
            forgotPassword: {
                el: "Ξέχασα τον κωδικό πρόσβασης",
                en: "Forgot password",
                it: "Password dimenticata"
            },
            
            passwordReset: {
                el: " Επαναφορά κωδικού πρόσβασης ",
                en: " Password Reset ",
                it: " Ripristino della password "
            },
            step1: {
                el: " Βήμα 1 - Αποκτήστε τον κωδικό επαλήθευσης ",
                en: " Step 1 - Get verification code ",
                it: " Passo 1 - Ottenere il codice di verifica "
            },
            step2: {
                el: " Βήμα 2 - Επαναφορά κωδικού πρόσβασης ",
                en: " Step 2 - Reset Password ",
                it: " Passo 2 - Reimpostare la password "
            },
            verificationCode: {
                el: "Κωδικός επαλήθευσης SMS",
                en: "Verification code",
                it: "Codice di verifica"
            },
            newPassword: {
                el: "Νέος κωδικός πρόσβασης",
                en: "New password",
                it: "Nuova password"
            },
            confirmNew: {
                el: "Επιβεβαίωση νέου κωδικού πρόσβασης",
                en: "Confirm new password",
                it: "Confermare la nuova password"
            },
            sendSms: {
                el: "Αποστολη SMS",
                en: "Send SMS",
                it: "Inviare SMS"
            },
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            knowPassword: {
                el: "Γνωρίζετε τον κωδικό πρόσβασής; ",
                en: "Do you know your password? ",
                it: "Conosci la tua password?"
            },
        }
    })
};
